// June & Louise: eigen size chart (metafield custom.jl_size_chart). Overgenomen uit het live thema (product-page.js).
// Eigen size chart (zonder app; snippets/jl-size-chart.liquid): openen/sluiten en cm/inches, zelfde gedrag als de
// Kiwi-pop-up. Raakt Kiwi niet aan: heeft Kiwi voor een product zelf een chart, dan verbergt de CSS de eigen link.
// Alles via gedelegeerde listeners, zodat het ook blijft werken als de sectie opnieuw wordt getekend (thema-editor).
(function () {
  // De winkel verkoopt in de VS: de pop-up opent altijd in inches (wens eigenaar, 4 okt 2026), cm is de tweede keuze.
  // Schakelt de bezoeker zelf naar cm, dan blijft dat zo tot de pagina opnieuw wordt geladen.
  const STANDAARD_EENHEID = 'inch';
  let gekozenEenheid = null;
  let laatsteLink = null;
  let scrollVoorOpenen = 0;

  function zetEenheid(modal, eenheid) {
    modal.querySelectorAll('[data-jl-sc-body]').forEach((body) => {
      body.hidden = body.dataset.jlScBody !== eenheid;
    });
    modal.querySelectorAll('[data-jl-sc-unit]').forEach((knop) => {
      const actief = knop.dataset.jlScUnit === eenheid;
      knop.classList.toggle('is-active', actief);
      knop.setAttribute('aria-pressed', actief ? 'true' : 'false');
    });
  }

  function open(link) {
    const modal = document.getElementById(link.getAttribute('aria-controls'));
    if (!modal) return;
    // De pop-up hoort direct onder <body>: zo kan geen enkele ouder (transform, overflow) hem afsnijden.
    if (modal.parentNode !== document.body) {
      document.querySelectorAll('body > [data-jl-sc]').forEach((oud) => { if (oud.id === modal.id) oud.remove(); });
      document.body.appendChild(modal);
    }
    zetEenheid(modal, gekozenEenheid || STANDAARD_EENHEID);
    laatsteLink = link;
    scrollVoorOpenen = window.scrollY;
    modal.hidden = false;
    modal.scrollTop = 0;
    document.documentElement.classList.add('jl-sc-open');
    // Eén frame wachten zodat de overgang (fade) start vanaf de beginstand.
    requestAnimationFrame(() => requestAnimationFrame(() => modal.classList.add('is-open')));
    try { modal.focus({ preventScroll: true }); } catch (fout) { modal.focus(); }
  }

  function sluit(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('jl-sc-open');
    if (Math.abs(window.scrollY - scrollVoorOpenen) > 1) window.scrollTo(0, scrollVoorOpenen);
    if (laatsteLink && document.contains(laatsteLink)) {
      try { laatsteLink.focus({ preventScroll: true }); } catch (fout) { laatsteLink.focus(); }
    }
  }

  document.addEventListener('click', (event) => {
    const doel = event.target instanceof Element ? event.target : null;
    if (!doel) return;
    const link = doel.closest('[data-jl-sc-open]');
    if (link) {
      event.preventDefault();
      open(link);
      return;
    }
    const sluiter = doel.closest('[data-jl-sc-close]');
    if (sluiter) {
      sluit(sluiter.closest('[data-jl-sc]'));
      return;
    }
    const eenheidKnop = doel.closest('[data-jl-sc-unit]');
    if (eenheidKnop) {
      gekozenEenheid = eenheidKnop.dataset.jlScUnit;
      zetEenheid(eenheidKnop.closest('[data-jl-sc]'), gekozenEenheid);
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('[data-jl-sc]:not([hidden])');
    if (!modal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      sluit(modal);
      return;
    }
    if (event.key === 'Tab') {
      // Focus binnen de pop-up houden.
      const knoppen = [...modal.querySelectorAll('button')].filter((knop) => knop.offsetParent !== null);
      if (!knoppen.length) return;
      const eerste = knoppen[0];
      const laatste = knoppen[knoppen.length - 1];
      if (event.shiftKey && (document.activeElement === eerste || document.activeElement === modal)) {
        event.preventDefault();
        laatste.focus();
      } else if (!event.shiftKey && document.activeElement === laatste) {
        event.preventDefault();
        eerste.focus();
      }
    }
  });
})();

// Kleurnaam-bubbel: bij het aantikken van een kleur-swatch verschijnt de kleurnaam
// kort boven het aangetikte bolletje (visuele bevestiging, vooral voor mobiel).
// Bewust in de swatch-rij geplaatst (niet in body) zodat popup-/app-CSS er niet op ingrijpt.
(function () {
  let bubbel = null;
  let timer = null;
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-option-button]');
    if (!knop || !knop.querySelector('.product-info__option-image')) return;
    const naam = knop.dataset.optionValue || knop.textContent.trim();
    const rij = knop.parentElement;
    if (!naam || !rij) return;
    if (!bubbel) {
      bubbel = document.createElement('span');
      bubbel.className = 'kleur-bubbel';
    }
    if (bubbel.parentElement !== rij) rij.appendChild(bubbel);
    rij.classList.add('heeft-kleur-bubbel');
    bubbel.textContent = naam;
    bubbel.style.left = Math.round(knop.offsetLeft + knop.offsetWidth / 2) + 'px';
    bubbel.style.top = Math.round(knop.offsetTop - 8) + 'px';
    bubbel.classList.add('is-zichtbaar');
    clearTimeout(timer);
    timer = setTimeout(() => bubbel.classList.remove('is-zichtbaar'), 1600);
  });
})();

// Productomschrijving: ✔-regels die in één alinea met <br> gescheiden staan, worden elk een eigen
// alinea (zoals Olivia NY), zodat de CSS-marges er ruimte tussen kunnen zetten. Fail-silent:
// alleen alinea's waarin een <br> direct door ✔ / ✓ wordt gevolgd worden gesplitst.
(function () {
  document.querySelectorAll('.product-info__description p').forEach((p) => {
    if (!p.querySelector('br') || !/[✔✓]/.test(p.textContent)) return;
    const delen = p.innerHTML.split(/<br\s*\/?>\s*(?=[✔✓])/);
    if (delen.length < 2) return;
    const fragment = document.createDocumentFragment();
    delen.forEach((deel) => {
      const html = deel.replace(/^(\s|<br\s*\/?>)+|(\s|<br\s*\/?>)+$/g, '');
      if (!html) return;
      const nieuw = document.createElement('p');
      nieuw.className = 'jl-vinkregel';
      nieuw.innerHTML = html;
      fragment.appendChild(nieuw);
    });
    if (fragment.childNodes.length) p.replaceWith(fragment);
  });
})();

// Mobiele galerij (floating dots, HHH-stijl): de hoogte van de galerij volgt de foto die in beeld is, zodat vierkante en
// staande foto's in dezelfde galerij elk schermbreed en onafgesneden getoond worden. Fail-silent; alleen <= 749px.
// De starthoogte komt al van de server (inline --jl-galerij-hoogte in snippets/product-gallery.liquid).
(function () {
  const mq = window.matchMedia('(max-width: 749px)');
  // Safari kent geen scroll anchoring: daar zelf corrigeren als de galerij boven beeld van hoogte wisselt (bv. kleurwissel).
  const browserAnkertZelf = !!(window.CSS && CSS.supports && CSS.supports('overflow-anchor', 'auto'));
  const start = (root) => {
    root.querySelectorAll('.product-gallery--mobile-floating_dots').forEach((gallery) => {
      const viewport = gallery.querySelector('[data-gallery-viewport]');
      if (!viewport || viewport.dataset.jlHoogte === '1') return;
      viewport.dataset.jlHoogte = '1';
      let timer = null;
      let vorige = null;
      const bijwerken = () => {
        timer = null;
        if (!mq.matches) { viewport.style.removeProperty('--jl-galerij-hoogte'); viewport.classList.remove('jl-galerij-klaar'); vorige = null; return; }
        const items = [...viewport.children].filter((el) => el.hasAttribute('data-media-id'));
        if (!items.length) return;
        const vpLinks = viewport.getBoundingClientRect().left;
        const midden = viewport.clientWidth / 2;
        let actief = items[0];
        for (const item of items) { if (item.getBoundingClientRect().left - vpLinks <= midden) actief = item; }
        const hoogte = Math.round(actief.getBoundingClientRect().height);
        if (hoogte <= 0 || hoogte === vorige) return;
        const onderkant = viewport.getBoundingClientRect().bottom;
        const bovenBeeld = vorige !== null && onderkant < window.innerHeight * 0.35;
        if (bovenBeeld) viewport.classList.remove('jl-galerij-klaar');
        viewport.style.setProperty('--jl-galerij-hoogte', hoogte + 'px');
        if (bovenBeeld && !browserAnkertZelf) window.scrollBy(0, hoogte - vorige);
        vorige = hoogte;
        window.setTimeout(() => viewport.classList.add('jl-galerij-klaar'), 60);
      };
      // Bewust een timer i.p.v. requestAnimationFrame: werkt ook als de browser tijdelijk geen frames tekent.
      const plan = () => { if (timer === null) timer = window.setTimeout(bijwerken, 80); };
      viewport.addEventListener('scroll', plan, { passive: true });
      viewport.addEventListener('scrollend', bijwerken);
      window.addEventListener('resize', plan);
      if (mq.addEventListener) mq.addEventListener('change', plan); else if (mq.addListener) mq.addListener(plan);
      viewport.querySelectorAll('img').forEach((img) => { if (!img.complete) img.addEventListener('load', plan, { once: true }); });
      viewport.querySelectorAll('video').forEach((video) => video.addEventListener('loadedmetadata', plan, { once: true }));
      bijwerken();
    });
  };
  start(document);
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();

// Kiwi gaat voor: zet Kiwi zijn eigen chart in de Size-kopregel, dan de eigen link verbergen (fallback voor browsers zonder :has).
(function () {
  function controleerKiwi() {
    var labels = document.querySelectorAll('.variant__label');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].querySelector('.ks-chart-container, ._ks_text')) labels[i].classList.add('jl-kiwi-aanwezig');
    }
  }
  controleerKiwi();
  new MutationObserver(controleerKiwi).observe(document.body, { childList: true, subtree: true });
})();
